import { Alert, Link, LinkButton, Text } from '@tonic-one/react';
import { Trans, useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { PolicyType } from '../../../../types/app';
import { QuarantineApi } from '@Apis';
import { useNavigateWithHandler } from '@Utils/hooks';
import { useOrgStore } from '../../../../models/useOrgModel';
import { useAccountStore } from '../../../../models/useAccountModel';
import { THIRD_PARTY_LINK } from '@Utils/casDocLink';
import AddInPanel from '../AddInPanel';
import { shouldShowGmailMailboxBanner } from '../utils';

const GmailAddIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigateWithHandler();
  const { orgId } = useOrgStore();
  const { groupCompanyGuid } = useAccountStore();
  const effectiveOrgId = orgId === 'all' ? groupCompanyGuid : orgId;

  const { data, isSuccess } = useQuery({
    queryKey: ['gmailDedicatedMailbox', effectiveOrgId],
    queryFn: async () =>
      (await QuarantineApi.apiGetGmailDedicatedQuarantineSetting()).data,
  });

  // Only a successful response with an empty mailbox list means "not
  // configured". Loading/error must not flash the banner or disable the panel.
  const showMailboxBanner = shouldShowGmailMailboxBanner({
    isSuccess,
    mailBoxList: data?.mailBoxList,
  });

  const infoBanner = showMailboxBanner ? (
    <Alert severity="info" variant="outline">
      <Text>
        {t('administration.addInGmail.quarantineMailbox.notConfigured')}{' '}
        <LinkButton
          display="inline-block"
          onClick={() => {
            navigate('/quarantine');
          }}
        >
          {t('administration.addInGmail.quarantineMailbox.setupNow')}
        </LinkButton>
      </Text>
    </Alert>
  ) : null;

  return (
    <AddInPanel
      policyTypes={[PolicyType.Gmail, PolicyType.GmailInline]}
      descriptionContent={
        <Text>
          <Trans i18nKey="administration.addInGmail.content">
            placeholder
            <Link href={THIRD_PARTY_LINK.gmailAddInMarketplace} target="_blank">
              placeholder
            </Link>
          </Trans>
        </Text>
      }
      notProvisionKey="administration.addInGmail.quarantineManagement.notProvision"
      apiCategory="gmail"
      infoBanner={infoBanner}
      forceDisable={showMailboxBanner}
    />
  );
};

export default GmailAddIn;
